import React from 'react';
import styles from './styles.module.scss';

export const DotsLoadingSpinner = () => {
  return (
    <div className={styles.container}>
      <span className={styles.loader}></span>
    </div>
  );
};
